module.exports = require("core-js/library/fn/object/get-own-property-descriptor");


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime-corejs2/core-js/object/get-own-property-descriptor.js
 ** module id = 615
 ** module chunks = 0
 **/